var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import React, { useState } from 'react';
import { UpdateCellWithTransformRequestValueTransformTypeEnum, WidgetType, } from '@common/api';
import { useLanguage } from '@base/LanguageProvider';
import FSButton from '@components/FSButton';
import Tags from '@shared/tags/Tags';
import Modal from '@shared/modal/Modal';
import Manager from '@shared/modal/Manager';
import TextInput from '@shared/input/TextInput';
import ModalHeader from '@shared/modal/ModalHeader';
import ModalFooter from '@shared/modal/ModalFooter';
import SelectInput from '@shared/input/SelectInput';
import { useTagContext } from '@data/tag/tagContext';
import { parseWidgetConfig } from '@data/widgets/widgetConfig';
import { useUpdateWidget } from '@data/widgets/widgetActions';
import { FormField, FormFieldLabel } from '@styled/Form';
import { ModalBody } from '@styled/Modal';
import { useActiveVersions } from '@data/hooks/versions';
function SimulationRowEditModal(props) {
    return (React.createElement(Modal, { width: 600 },
        React.createElement(SimulationRowEdit, __assign({}, props))));
}
var SimulationRowEdit = function (props) {
    var L = useLanguage().L;
    var activeVersions = useActiveVersions();
    var tagData = useTagContext().tagData;
    var updateWidget = useUpdateWidget();
    var _a = __read(useState(props.row
        ? props.row
        : {
            label: '',
            tagIds: [],
            editType: UpdateCellWithTransformRequestValueTransformTypeEnum.Add,
            targetVersionTagId: activeVersions ? activeVersions[0].versionTagId : 0,
        }), 2), row = _a[0], setRow = _a[1];
    var _b = __read(useState({}), 2), invalid = _b[0], setInvalid = _b[1];
    var _c = __read(useState(null), 2), generatorTagId = _c[0], setGeneratorTagId = _c[1];
    var validate = function (row) {
        var invalid = {};
        if (row.sourceVersionTagId === row.targetVersionTagId) {
            invalid.targetVersionTagId = L("Target version can't be same as source version.");
        }
        if (row.targetVersionTagId === null) {
            invalid.targetVersionTagId = L('Please select target version.');
        }
        if ((row.editType === UpdateCellWithTransformRequestValueTransformTypeEnum.Add ||
            row.editType === UpdateCellWithTransformRequestValueTransformTypeEnum.Mul) &&
            row.sourceVersionTagId == null) {
            invalid.sourceVersionTagId = L('Please select source version.');
        }
        return invalid;
    };
    var done = function () { return __awaiter(void 0, void 0, void 0, function () {
        var editedRow, _invalid, widgetCopy, widgetCopyConfig_1;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    editedRow = __assign({}, row);
                    _invalid = validate(editedRow);
                    if (!(Object.keys(_invalid).length > 0)) return [3 /*break*/, 1];
                    setInvalid(_invalid);
                    return [3 /*break*/, 3];
                case 1:
                    widgetCopy = __assign({}, props.widget);
                    widgetCopyConfig_1 = parseWidgetConfig(widgetCopy.config, WidgetType.SIMULATION);
                    if (!widgetCopyConfig_1.dataEditorRows) {
                        widgetCopyConfig_1.dataEditorRows = [];
                    }
                    if (props.row !== undefined && props.rowIdx !== undefined) {
                        widgetCopyConfig_1.dataEditorRows[props.rowIdx] = editedRow;
                    }
                    else {
                        if (generatorTagId &&
                            tagData.tagsByParentId[generatorTagId] &&
                            tagData.tagsByParentId[generatorTagId].length > 0) {
                            (_a = tagData.tagsByParentId[generatorTagId]) === null || _a === void 0 ? void 0 : _a.forEach(function (childTag) {
                                var _a;
                                (_a = widgetCopyConfig_1.dataEditorRows) === null || _a === void 0 ? void 0 : _a.push(__assign(__assign({}, editedRow), { label: "".concat(childTag.name).concat(editedRow.label), tagIds: __spreadArray(__spreadArray([], __read(editedRow.tagIds), false), [childTag.id], false) }));
                            });
                        }
                        else {
                            widgetCopyConfig_1.dataEditorRows.push(editedRow);
                        }
                    }
                    widgetCopy.config = JSON.stringify(widgetCopyConfig_1);
                    return [4 /*yield*/, updateWidget.mutateAsync(widgetCopy)];
                case 2:
                    _b.sent();
                    Manager.closeModal();
                    _b.label = 3;
                case 3: return [2 /*return*/];
            }
        });
    }); };
    var onTagSlicerTagSelect = function (tagId) {
        var col = __assign({}, row);
        col.tagIds.push(tagId);
        setRow(col);
    };
    var onTagSlicerTagRemove = function (tagId) {
        var col = __assign({}, row);
        col.tagIds = col.tagIds.filter(function (tid) { return tid !== tagId; });
        setRow(col);
    };
    var deleteRow = function () { return __awaiter(void 0, void 0, void 0, function () {
        var widgetCopy, widgetCopyConfig;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    widgetCopy = __assign({}, props.widget);
                    widgetCopyConfig = parseWidgetConfig(widgetCopy.config, WidgetType.SIMULATION);
                    widgetCopyConfig.dataEditorRows.splice((_a = props.rowIdx) !== null && _a !== void 0 ? _a : 0, 1);
                    widgetCopy.config = JSON.stringify(widgetCopyConfig);
                    return [4 /*yield*/, updateWidget.mutateAsync(widgetCopy)];
                case 1:
                    _b.sent();
                    Manager.closeModal();
                    return [2 /*return*/];
            }
        });
    }); };
    var columnTags = [];
    if (row.tagIds) {
        columnTags = row.tagIds.map(function (tagId) { return tagData.tagById[tagId]; });
    }
    var title = props.row ? "".concat(L('Editing row'), " ").concat(props.row.label ? props.row.label : '') : L('Create new row');
    var versionOptions = activeVersions.map(function (v) { return ({ label: v.name, value: v.versionTagId }); });
    return (React.createElement(React.Fragment, null,
        React.createElement(ModalHeader, { title: title }),
        React.createElement(ModalBody, null,
            React.createElement("form", null,
                React.createElement(TextInput, { label: L('Label'), value: row.label, name: "title", onChange: function (e) { return setRow(__assign(__assign({}, row), { label: e.target.value })); }, bottomMargin: true }),
                React.createElement(SelectInput, { name: "type", value: row.editType, label: L('Edit type'), onChange: function (e) { return setRow(__assign(__assign({}, row), { editType: e.target.value })); }, options: [
                        { label: L('Add'), value: UpdateCellWithTransformRequestValueTransformTypeEnum.Add },
                        { label: L('Multiply'), value: UpdateCellWithTransformRequestValueTransformTypeEnum.Mul },
                        { label: L('Set'), value: UpdateCellWithTransformRequestValueTransformTypeEnum.Set },
                        { label: L('Percent change'), value: 'PERCENT' },
                    ], bottomMargin: true }),
                React.createElement(SelectInput, { name: "type", value: row.sourceVersionTagId || null, label: L('Source version'), onChange: function (e) { return setRow(__assign(__assign({}, row), { sourceVersionTagId: e.target.value })); }, options: versionOptions, bottomMargin: true, invalidString: invalid.sourceVersionTagId }),
                React.createElement(SelectInput, { name: "type", value: row.targetVersionTagId, label: L('Target version'), onChange: function (e) { return setRow(__assign(__assign({}, row), { targetVersionTagId: e.target.value })); }, options: versionOptions, bottomMargin: true, invalidString: invalid.targetVersionTagId }),
                React.createElement(FormField, { "$bottomSpace": true },
                    React.createElement(FormFieldLabel, null, L('Row tags')),
                    React.createElement(Tags, { tags: columnTags, select: onTagSlicerTagSelect, remove: onTagSlicerTagRemove })),
                props.row && typeof props.rowIdx === 'number' && (React.createElement(FormField, null,
                    React.createElement(FSButton, { "$type": "secondary", "$color": "error", type: "button", title: L('Delete this row'), onClick: deleteRow }))),
                !props.row && (React.createElement(FormField, { "$bottomSpace": true },
                    React.createElement(FormFieldLabel, null, L('Select parent tag to generate multiple rows')),
                    React.createElement(Tags, { tags: generatorTagId ? [tagData.tagById[generatorTagId]] : [], select: function (tagId) { return setGeneratorTagId(tagId); }, remove: function () { return setGeneratorTagId(null); } }))))),
        React.createElement(ModalFooter, { done: done })));
};
export default SimulationRowEditModal;
